"use client";

import { useWebchatStore, useObserveToggle } from "../store";
import { ToggleBottom } from "./ToggleBottom";
import { WebChatHeader } from "./WebChatHeader";
import { cn } from "@deputy-ai/common";
import { Transition } from "@headlessui/react";
import { useEffect, useState, type ReactNode } from "react";

export function WebchatLayout({
  children,
}: {
  children: ReactNode;
}): ReactNode {
  useObserveToggle();
  const {
    use: { bridge, visible, styleOverride },
  } = useWebchatStore();

  const [visibleDelay, setVisibleDelay] = useState(visible);

  useEffect(() => {
    bridge?.register();
    return () => bridge?.unregister();
  }, [bridge]);

  useEffect(() => {
    setTimeout(() => {
      setVisibleDelay(visible);
    }, 0);
  }, [visible, setVisibleDelay]);

  return (
    <>
      {styleOverride && <style>{styleOverride}</style>}
      <div className="webchat h-dvh w-full overflow-hidden">
        <Transition show={visibleDelay} appear={true} unmount={false}>
          <div
            className={cn(
              // Base styles
              "xsm:p-4 xsm:pb-20 flex h-full flex-col justify-end overflow-hidden transition ease-in-out",
              // Shared closed styles
              "data-closed:opacity-0",
              // Entering styles
              "data-enter:duration-150 data-enter:data-closed:translate-y-full",
              // Leaving styles
              "data-leave:duration-150 data-leave:data-closed:translate-y-full"
            )}
          >
            <div
              className={cn(
                "xsm:rounded-xl relative flex h-full flex-col overflow-hidden bg-white shadow-sm"
              )}
            >
              <WebChatHeader />
              {children}
            </div>
          </div>
        </Transition>
      </div>
      <ToggleBottom />
    </>
  );
}
